import { render, staticRenderFns } from "./groupRecipient.vue?vue&type=template&id=55e7ea3e&"
import script from "./groupRecipient.vue?vue&type=script&lang=js&"
export * from "./groupRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports